export type ApplicationEnvironmentTone = "development" | "staging";

export interface ApplicationEnvironmentPresentation {
  label: string;
  tone: ApplicationEnvironmentTone;
}

const ENVIRONMENT_LABELS: Readonly<Record<string, string>> = {
  development: "DEV",
  "local-auth": "LOCAL AUTH",
  "local-brev-deploy": "LOCAL DEPLOY",
};

export const getApplicationEnvironmentPresentation = (
  mode: string,
): ApplicationEnvironmentPresentation | undefined => {
  const normalizedMode = mode.trim().toLowerCase();

  if (!normalizedMode || normalizedMode === "production") return undefined;

  return {
    label: ENVIRONMENT_LABELS[normalizedMode] ?? normalizedMode.toUpperCase(),
    tone: normalizedMode === "staging" ? "staging" : "development",
  };
};
